/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SILENT_LOGIN,
  UPDATE_PROFILE,
  SEND_MAIL,
  SEND_MAIL_FAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_FAIL,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAIL,
  LOADER,
  RESET_EMPTY,
  SEND_MAIL_EMPTY,
  UPDATE_PASSWORD_EMPTY,
  LOGIN_SUCCESS_WITH_ACCESS_TOKEN,
  LOGIN_SUCCESS_WITH_ACCESS_TOKEN_DONE,
  GENERATE_OTP_DATA,
  VERIFY_OTP_DATA,
  SUBMIT_NEW_PASSWORD,
  GENERATE_OTP_DATA_ERROR
} from 'src/actions/accountActions';

const initialState = {
  user: null,
  message: null,
  errorMessage: null,
  resetPassword: null,
  resetError: null,
  updatePassword: null,
  updateError: null,
  isLoading: false,
  loadingText: '',
  isLoginWithAccessToken: false,
  generateOTPData: null,
  generateOTPDataError: null,
  verifyOTPData: null,
  submitNewPasswordData: null,
  isClientChatBot: false
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
        draft.loadingText = draft.payload || '';
      });
    }

    case LOGIN_REQUEST: {
      return produce(state, draft => {
        // Ensure we clear current session
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const { user } = action.payload;

      return produce(state, draft => {
        draft.user = user;
        draft.isLoading = false;
        localStorage.removeItem('captchaRequestUUID');
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, draft => {
        // Maybe store error
        draft.isLoading = false;
      });
    }

    case LOGOUT: {
      return produce(state, draft => {
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { user } = action.payload;

      return produce(state, draft => {
        draft.user = user;
      });
    }

    case SEND_MAIL: {
      const message = action.payload;
      return produce(state, draft => {
        draft.message = message;
        draft.isLoading = false;
      });
    }

    case SEND_MAIL_FAIL: {
      const errorMessage = action.payload;
      return produce(state, draft => {
        draft.errorMessage = errorMessage;
        draft.isLoading = false;
      });
    }

    case SEND_MAIL_EMPTY: {
      return produce(state, draft => {
        draft.errorMessage = null;
        draft.message = null;
      });
    }

    case RESET_PASSWORD: {
      const resetPassword = action.payload;
      return produce(state, draft => {
        draft.resetPassword = resetPassword;
        draft.isLoading = false;
      });
    }

    case RESET_PASSWORD_FAIL: {
      const resetError = action.payload;
      return produce(state, draft => {
        draft.resetError = resetError;
        draft.isLoading = false;
      });
    }

    case RESET_EMPTY: {
      return produce(state, draft => {
        draft.resetPassword = null;
        draft.resetError = null;
      });
    }

    case UPDATE_PASSWORD: {
      const updatePassword = action.payload;
      return produce(state, draft => {
        draft.updatePassword = updatePassword;
        draft.isLoading = false;
      });
    }

    case UPDATE_PASSWORD_FAIL: {
      const updateError = action.payload;
      return produce(state, draft => {
        draft.updateError = updateError;
        draft.isLoading = false;
      });
    }

    case UPDATE_PASSWORD_EMPTY: {
      return produce(state, draft => {
        draft.updateError = null;
        draft.updatePassword = null;
      });
    }

    case UPDATE_PROFILE: {
      const { user } = action.payload;
      return produce(state, draft => {
        draft.user = user;
      });
    }

    case LOGIN_SUCCESS_WITH_ACCESS_TOKEN: {
      return produce(state, draft => {
        draft.isLoginWithAccessToken = true;
        draft.isClientChatBot = action.payload || false;
      });
    }

    case LOGIN_SUCCESS_WITH_ACCESS_TOKEN_DONE: {
      return produce(state, draft => {
        draft.isLoginWithAccessToken = false;
        draft.isClientChatBot = false;
      });
    }

    case GENERATE_OTP_DATA: {
      const data = action.payload;
      return produce(state, draft => {
        draft.isLoading = false;
        draft.generateOTPData = data;
      });
    }

    case GENERATE_OTP_DATA_ERROR: {
      const data = action.payload;
      return produce(state, draft => {
        draft.isLoading = false;
        draft.generateOTPDataError = data;
      });
    }

    case VERIFY_OTP_DATA: {
      const data = action.payload;
      return produce(state, draft => {
        draft.isLoading = false;
        draft.verifyOTPData = data;
      });
    }

    case SUBMIT_NEW_PASSWORD: {
      const data = action.payload;
      return produce(state, draft => {
        draft.isLoading = false;
        draft.submitNewPasswordData = data;
        localStorage.removeItem('captchaRequestUUID');
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
